export default __webpack_public_path__ + "static/media/successImage.9183092f.png";